export { isNative, getPlatform } from './platform';

// No native bootstrap in the browser. Native features live in /mobile-app (Expo).
export async function initNativeLayer() {
  /* no-op on web */
}
